import React, { FunctionComponent } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Box, constants, OptionProps, Select } from '@match/react-component-library';
import { DeviceChoicesType } from 'modules/hooks/useDropDownChoices';

const { SPACE } = constants;

interface DeviceDropdownProps {
  deviceChoices: DeviceChoicesType[];
  onDeviceSelect: (selection?: OptionProps<{}> | undefined) => void;
}

export const DeviceDropdown: FunctionComponent<DeviceDropdownProps> = ({
  deviceChoices,
  onDeviceSelect,
}) => {
  const intl = useIntl();

  return (
    <Box marginBottom={SPACE.XLARGE}>
      <Box marginBottom={SPACE.SMALL}>
        <FormattedMessage {...messages.device} />
      </Box>
      <Select
        buttonAriaLabelClear={intl.formatMessage(messages.selectAriaClear)}
        buttonAriaLabelDownArrow={intl.formatMessage(messages.selectAriaDown)}
        buttonAriaLabelUpArrow={intl.formatMessage(messages.selectAriaUp)}
        name="deviceSelect"
        id="deviceSelect"
        isCombobox
        onSelect={onDeviceSelect}
        placeholder={intl.formatMessage(messages.selectDevice)}
      >
        {deviceChoices.map((device: DeviceChoicesType) => {
          return (
            <Select.Option key={device.value} value={device.value}>
              {device.name}
            </Select.Option>
          );
        })}
      </Select>
    </Box>
  );
};

const messages = defineMessages({
  device: {
    id: 'src/modules/pages/ContactUsPage/ContactUsSC3/DeviceDropdown/DeviceDropdown:device',
    description: 'device section header',
    defaultMessage: 'Device',
  },
  selectDevice: {
    id: 'src/modules/pages/ContactUsPage/ContactUsSC3/DeviceDropdown/DeviceDropdown:selectDevice',
    description: 'select device dropdown placeholder',
    defaultMessage: 'Select Device',
  },
  selectAriaUp: {
    id: 'src/modules/pages/ContactUsPage/ContactUsSC3/DeviceDropdown/DeviceDropdown:selectAriaUp',
    description: 'up text',
    defaultMessage: 'up',
  },
  selectAriaDown: {
    id: 'src/modules/pages/ContactUsPage/ContactUsSC3/DeviceDropdown/DeviceDropdown:selectAriaDown',
    description: 'down text',
    defaultMessage: 'down',
  },
  selectAriaClear: {
    id:
      'src/modules/pages/ContactUsPage/ContactUsSC3/DeviceDropdown/DeviceDropdown:selectAriaClear',
    description: 'clear text',
    defaultMessage: 'clear',
  },
});
